/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceModelRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.deviceModels', {
            url: '/deviceModels',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value, types.authority.SUB_CUSTOMER_ADMIN.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'device-model.device-models'
            },
            ncyBreadcrumb: {
                label: '{"icon": "devices_other", "label": "device-model.device-models"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, deviceModelTableConfig) {
                        return deviceModelTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/device-model/device-model.routes.js